export const ventaModel = {
  td: '',
  nd: null,
  cl: null,
  nc: null,
  lst: [],
};
